__turbopack_context__.v({
  "avatarBlurred": "CandidateCardSnow-module__b9NpbG__avatarBlurred",
  "avatarFallback": "CandidateCardSnow-module__b9NpbG__avatarFallback",
  "avatarImage": "CandidateCardSnow-module__b9NpbG__avatarImage",
  "avatarPanel": "CandidateCardSnow-module__b9NpbG__avatarPanel",
  "avatarWrapper": "CandidateCardSnow-module__b9NpbG__avatarWrapper",
  "bottom": "CandidateCardSnow-module__b9NpbG__bottom",
  "card": "CandidateCardSnow-module__b9NpbG__card",
  "cta": "CandidateCardSnow-module__b9NpbG__cta",
  "ctaIcon": "CandidateCardSnow-module__b9NpbG__ctaIcon",
  "headings": "CandidateCardSnow-module__b9NpbG__headings",
  "highlights": "CandidateCardSnow-module__b9NpbG__highlights",
  "meta": "CandidateCardSnow-module__b9NpbG__meta",
  "metaSeparator": "CandidateCardSnow-module__b9NpbG__metaSeparator",
  "moreSkills": "CandidateCardSnow-module__b9NpbG__moreSkills",
  "name": "CandidateCardSnow-module__b9NpbG__name",
  "recruiterLogo": "CandidateCardSnow-module__b9NpbG__recruiterLogo",
  "recruiterLogoPlaceholder": "CandidateCardSnow-module__b9NpbG__recruiterLogoPlaceholder",
  "root": "CandidateCardSnow-module__b9NpbG__root",
  "skill": "CandidateCardSnow-module__b9NpbG__skill",
  "skillEmoji": "CandidateCardSnow-module__b9NpbG__skillEmoji",
  "skillLogo": "CandidateCardSnow-module__b9NpbG__skillLogo",
  "skillsLabel": "CandidateCardSnow-module__b9NpbG__skillsLabel",
  "skillsList": "CandidateCardSnow-module__b9NpbG__skillsList",
  "skillsPanel": "CandidateCardSnow-module__b9NpbG__skillsPanel",
  "title": "CandidateCardSnow-module__b9NpbG__title",
  "top": "CandidateCardSnow-module__b9NpbG__top",
});
